<template>
    <div class="alarmPanel_box animate__animated animate__fadeIn">
        <div class="alarmPanel">
            <!-- 混合报警详情 -->
            <div class="content_box">

                <div class="search_box">
                    <div class="box_line">

                        <div class="line_input">
                            <div class="input_title">防区</div>
                            <el-select size="small" class="select_box" v-model="searchZoneNo"
                                :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
                                <el-option label="请选择" :value="null"></el-option>
                                <el-option label="全防区" :value="-1"></el-option>
                                <el-option v-for="(item, index) in zones" :label="item.Zone.zoneName"
                                    :value="item.Zone.id+1" :key="index" v-if="index<8"></el-option>
                            </el-select>
                        </div>

                        <div class="line_input">
                            <div class="input_title">触发类型</div>
                            <el-select size="small" class="select_box" v-model="searchType"
                                :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in types" :label="item" :value="item"></el-option>
                            </el-select>
                        </div>
                        <div class="line_input">
                            <div class="input_title">描述</div>
                            <el-select size="small" class="select_box" v-model="searchDescribe"
                                :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in describes" :label="item" :value="item"></el-option>
                            </el-select>
                        </div>
                    </div>

                    <div class="box_line">

                        <div class="line_input">
                            <div class="input_title">触发时间</div>
                            <el-date-picker size="small" v-model="searchCaptureAt" type="datetimerange"
                                value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期" style="width: 392px;"></el-date-picker>
                        </div>

                        <div class="search-btn" @click="fnGetAlarmPanelList"><span>搜索</span></div>
                    </div>
                </div>

                <div class="cont_list">
                    <div class="list_title">
                        <div class="title_item">防区编号</div>
                        <div class="title_item">触发类型</div>
                        <div class="title_item">描述</div>
                        <div class="title_item">触发时间</div>
                        <div class="title_item">创建时间</div>
                    </div>
                    <div class="list_boxes">
                        <div class="list_box">
                            <div class="box_line" v-for="(item, index) in AlarmPanelList" :key="index">
                                <div class="list_item">
                                    {{ item.zone_no == -1 ? '全防区' : zones[item.zone_no-1].Zone.zoneName }}
                                </div>
                                <div class="list_item">{{ item.type }}</div>
                                <div class="list_item">{{ item.describe }}</div>
                                <div class="list_item">{{ item.capture_at }}</div>
                                <div class="list_item">{{ item.create_at }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="cont_pages">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :page-sizes="pageSizes" :page-size="pageSize" :current-page="currentPage"
                        layout="total, sizes, prev, pager, next, jumper" :total="pageTotal" />
                </div>
            </div>

            <div class="data_list">
                <div class="title">混合报警({{ AlarmPanelData.length }}台)</div>
                <div class="list_title">
                    <div class="title_item">设备编号</div>
                    <div class="title_item">在线状态</div>
                    <div class="title_item">布防状态</div>
                    <div class="title_item">报警状态</div>
                    <div class="title_item">操作</div>
                </div>
                <div class="list_box">
                    <div v-if="AlarmPanelData">
                        <div class="box_line" v-for="(item, index) in AlarmPanelData" :key="item.id"
                            @click="fnAlarmPanelToggle(item, index, false)"
                            :class="currentAlarmPanelIndex == index ? 'active' : ''">
                            <div class="line_item">{{ item.number }}</div>
                            <div class="line_item">
                                <span v-if="!item.isOnline" style="color: #E6A23C">离线</span>
                                <span v-else>在线</span>
                            </div>
                            <div class="line_item">
                                <span v-if="!item.arming" style="color: #E6A23C">已撤防</span>
                                <span v-else style="color: #439fe3">已布防</span>
                            </div>
                            <div class="line_item">
                                <span v-if="item.alarm" style="color: #E6A23C">报警中</span>
                                <span v-else>正常</span>
                            </div>
                            <div class="line_item">

                                <el-button type="primary" size="mini"
                                    @click.stop="fnAlarmPanelToggle(item, index, true)">防区
                                </el-button>

                                <el-button type="success" size="mini" v-if="!item.arming"
                                    @click="fnControl(item.number,'/arm/1?ways=away&format=json','布防')">布防
                                </el-button>
                                <el-button type="danger" size="mini" v-else
                                    @click="fnControl(item.number,'/disarm/1?format=json','撤防')">撤防
                                </el-button>
                                <el-button type="info" size="mini"
                                    @click="fnControl(item.number,'/clearAlarm/1?format=json','消警')">消警
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dialog_zones animate__animated animate__fadeIn" v-if="zonesVisible">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="防区设置" top="20vh"
                    center :visible.sync="zonesVisible">
                    <div class="cont_list" style="width: 432px;height: 490px;color: #fff;">
                        <div class="list_title" style="width: 432px;">
                            <div class="title_item" style="width: 180px;">防区编号</div>
                            <div class="title_item" style="width: 150px;">防区名称</div>
                        </div>
                        <div class="list_boxes" style="width: 432px;height: 440px;">
                            <div class="list_box" style="width: 432px;height: 440px;">
                                <div class="box_line" v-for="(item, index) in zones" :key="index" v-if="index<8">
                                    <div class="list_item" style="width: 180px;">{{ item.Zone.id + 1 }}</div>
                                    <div class="list_item" style="width: 150px;">
                                        <input type="text" class="input_box" @change="fnEditZone(item.Zone)"
                                            placeholder="请输入防区名称" v-model="item.Zone.zoneName" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-dialog>
            </div>

        </div>
    </div>
</template>

<script>
    import request from '@/utils/request';
    import APP from '@/utils/base';
    import {
        getEqptInfo,
        removeEqptInfo
    } from '@/utils/auth';

    export default {
        data() {
            return {
                pageSize: 12,
                pageSizes: [12, 20, 50, 100, 500, 1000],
                currentPage: APP.PAGE.SKIP_PAGE,
                searchZoneNo: null,
                searchType: null,
                searchDescribe: null,
                searchCaptureAt: null,
                alarmPanelNumber: null,
                pageTotal: 0,
                currentAlarmPanelIndex: 0, // 右侧列表选项
                AlarmPanelData: [], // 右侧混合报警列表
                selectData: [], // 当前显示的数据
                AlarmPanelList: [], // 当前混合报警列表数据
                showImgWin: false,
                bigImg: '',
                isIndex: false,
                indexMsg: null,
                zones: [],
                zonesVisible: false,
                types: [],
                describes: [],
            };
        },
        created() {
            this.fnGetAlarmPanelData(false);
        },
        beforeDestroy() {
            removeEqptInfo();
        },
        methods: {
            // 分页
            handleSizeChange(val) {
                this.pageSize = val;
                this.fnGetAlarmPanelList();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.fnGetAlarmPanelList();
            },
            fnEditZone(_zone) {

                request({
                        url: 'alarmPanel/request',
                        method: 'POST',
                        data: {
                            number: this.alarmPanelNumber,
                            method: 'PUT',
                            url: '/ISAPI/SecurityCP/Configuration/zones/' + _zone.id + '?format=json',
                            upload_data: {
                                Zone: {
                                    id: _zone.id,
                                    zoneName: _zone.zoneName
                                }
                            }
                        }
                    })
                    .then(res => {
                        let data = res.data
                        if (data.errorCode != 1) {
                            this.$message.error(data.errorMsgStr);
                        } else {
                            this.$message.success('修改成功');
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });

            },
            fnGetZones(_isVisible) {
                request({
                        url: 'alarmPanel/request',
                        method: 'POST',
                        data: {
                            number: this.alarmPanelNumber,
                            method: 'GET',
                            url: '/ISAPI/SecurityCP/Configuration/zones?format=json',
                        }
                    })
                    .then(res => {
                        let data = res.data
                        if (data.errorCode != 1) {
                            this.$message.error(data.errorMsgStr);
                        } else {
                            this.zones = data.List
                            console.log(this.zones);
                            this.zonesVisible = _isVisible
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });

            },
            fnControl(_number, _type, _typeMsg) {
                request({
                        url: 'alarmPanel/request',
                        method: 'POST',
                        data: {
                            number: _number,
                            method: 'PUT',
                            url: '/ISAPI/SecurityCP/control' + _type,
                        }
                    })
                    .then(res => {
                        let data = res.data
                        if (data.errorCode != 1) {
                            this.$message.error(data.errorMsgStr);
                        } else {
                            this.$message.success(_typeMsg + "成功！")
                            this.fnGetAlarmPanelData(true);
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });

            },
            // 获取混合报警设备列表
            fnGetAlarmPanelData(_isControl) {
                request({
                        url: 'alarmPanel/numbers',
                        method: 'GET'
                    })
                    .then(res => {
                        let _data = res.data;
                        this.AlarmPanelData = _data.list;
                        this.describes = _data.describe;
                        this.types = _data.type;
                        if (!_isControl) {
                            this.alarmPanelNumber = this.AlarmPanelData[0] ? this.AlarmPanelData[0].number : '';
                            this.fnGetZones(false)
                        }

                        this.fnGetAlarmPanelList();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 混合报警在线状态
            fnOnlineStatusText(_heartbeatTime) {
                return APP.fnOnlineStatusText(_heartbeatTime);
            },
            // 获取当前混合报警的详情列表
            fnGetAlarmPanelList() {
                let _number = this.alarmPanelNumber;
                if (_number) {
                    request({
                            url: 'alarmPanel/details',
                            method: 'GET',
                            params: {
                                page: this.currentPage,
                                size: this.pageSize,
                                number: _number,
                                zone_no: this.searchZoneNo,
                                type: this.searchType,
                                describe: this.searchDescribe,
                                capture_at: this.searchCaptureAt,
                            }
                        })
                        .then(res => {
                            let _data = res.data.list;
                            this.AlarmPanelList = _data;
                            this.pageTotal = res.data.count;
                        })
                        .catch(err => {
                            this.$message.error(err.data);
                        });
                }
            },
            // 切换右侧设备号
            fnAlarmPanelToggle(item, index, is_zone) {

                this.currentAlarmPanelIndex = index;
                let alarmPanelNumber = this.alarmPanelNumber + ''
                this.alarmPanelNumber = item.number;
                if (is_zone || alarmPanelNumber != item.number) {
                    this.fnGetZones(is_zone)
                }

                this.fnGetAlarmPanelList();
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import '~@/styles/mixin.scss';

    .box_line {
        >>>.el-input__inner {
            width: 211px;
            height: 30px;
            border-radius: 2px;
            border: none;
            color: rgba(77, 180, 244, 0.7);
            background: transparent;

            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }

        >>>.el-select {
            .el-input {
                .el-select__caret {
                    color: rgba(77, 180, 244, 0.7);
                }
            }
        }

        >>>.el-select-dropdown {
            background-color: #091120;
            border: 1px solid rgba(77, 180, 244, 1);
        }

        >>>.popper__arrow {
            border-bottom-color: rgba(77, 180, 244, 1) !important;
        }

        >>>.el-select-dropdown__item {
            color: rgba(77, 180, 244, 0.7);
        }

        >>>.el-select-dropdown__item:hover {
            color: #409eff;
        }

        >>>.el-select-dropdown__item.hover {
            color: #409eff;
        }

        >>>.el-input__icon {
            color: rgba(77, 180, 244, 0.7);
        }

        >>>.el-range-input {
            color: rgba(77, 180, 244, 0.7);
            background: transparent;

            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }

        >>>.el-range-separator {
            color: rgba(77, 180, 244, 0.7);
        }
    }

    .alarmPanel_box {
        width: 1920px;
        height: 858px;
        position: relative;
        overflow: hidden;

        .alarmPanel {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }

    .search_box {
        height: 84px;
        width: 1080px;
        margin-top: 24px;
        margin-left: 20px;
        margin-bottom: 20px;
        @include flex-box(space-between, center, column);

        .box_line {
            width: 1080px;
            height: 32px;
            @include flex-box(flex-start, center);

            .line_input {
                min-width: 280px;
                height: 30px;
                margin-right: 10px;
                border-top-right-radius: 1px;
                border-bottom-right-radius: 1px;
                background-color: rgba(49, 88, 128, 0.4);
                @include flex-box(flex-start, center);

                .input_title {
                    width: 69px;
                    height: 30px;
                    font-size: 14px;
                    color: #9bf9fc;
                    border-radius: 2px;
                    background-color: rgba(155, 249, 252, 0.1);
                    @include flex-box(center, center);
                }

                .input_box {
                    width: 211px;
                    height: 30px;
                    line-height: 30px;
                    padding-left: 15px;
                    color: rgba(77, 180, 244, 0.7);
                    font-size: 12px;
                    border-radius: 2px;
                    outline: none;
                    background: transparent;
                    border: none;

                    &::-webkit-input-placeholder {
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: rgba(77, 180, 244, 0.7);
                    }
                }

                .select_box {
                    width: 211px;
                    height: 30px;
                    border-radius: 2px;
                }
            }

            .add_person {
                width: 106px;
                height: 32px;
                margin-right: 5px;
                cursor: pointer;
                background: url(../../../assets/img/per_list_add.png) no-repeat;
                background-size: 100% 100%;
            }

            .to_face {
                width: 159px;
                height: 32px;
                margin-right: 5px;
                cursor: pointer;
                background: url(../../../assets/img/per_btn_toaccess.png) no-repeat;
                background-size: 100% 100%;
            }

            .to_custom {
                width: 159px;
                height: 32px;
                margin-right: 5px;
                cursor: pointer;
                background: url(../../../assets/img/per_btn_tocustom.png) no-repeat;
                background-size: 100% 100%;
            }

            .to_export {
                width: 106px;
                height: 32px;
                margin-right: 5px;
                cursor: pointer;
                background: url(../../../assets/img/per_btn_export.png) no-repeat;
                background-size: 100% 100%;
            }

            .to_weixin {
                width: 216px;
                height: 32px;
                cursor: pointer;
                background: url(../../../assets/img/per_btn_toweixin.png) no-repeat;
                background-size: 100% 100%;
            }

            .upload_btn {
                width: 216px;
                height: 32px;
                background: url(../../../assets/img/per_bg_g.png) no-repeat;
                background-size: 100% 100%;
                color: rgba(255, 255, 255, 0.8);
                font-size: 14px;
                cursor: pointer;
                @include flex-box(center, center);

                span {
                    margin-top: -5px;
                }
            }
        }
    }



    .content_box {
        position: relative;
        overflow: hidden;
        width: 1080px;
        height: 848px;
        margin: 10px 0 0 20px;


        .cont_list {
            width: 1080px;
            margin: 0 10px;
            height: 660px;
            border-radius: 10px;
            background-color: rgba(29, 68, 149, 0.1);

            .list_title {
                width: 1080px;
                height: 48px;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(flex-start, center);

                .title_item {
                    width: 216px;
                    height: 48px;
                    @include flex-box(center, center);
                }
            }

            .list_boxes {
                width: 1080px;
                // margin-left: 30px;
                height: 612px;
                position: relative;
                overflow: hidden;

                .list_box {
                    position: absolute;
                    left: 0;
                    right: -25px;
                    top: 0;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: auto;

                    .box_line {
                        width: 1080px;
                        height: 70px;
                        margin-top: 5px;
                        font-size: 16px;
                        color: #ffffff;
                        border-bottom: 1px dashed #1d4495;
                        @include flex-box(flex-start, center);

                        &:hover {
                            background-color: rgba(49, 88, 128, 0.4);
                        }

                        .list_item {
                            width: 216px;
                            height: 70px;
                            @include flex-box(center, center);
                        }
                    }
                }
            }
        }

        .cont_pages {
            width: 1080px;
            height: 68px;
            @include flex-box(flex-start, center);

            >>>.el-pagination__total {
                color: #439fe3;
                font-size: 14px !important;
            }

            >>>.el-input__inner {
                background-color: rgba(49, 88, 128, 0.5) !important;
                border: none !important;
                color: #439fe3 !important;
            }

            >>>.el-pagination__jump {
                color: #439fe3;
                font-size: 14px !important;
            }

            >>>.el-select__caret {
                color: #439fe3;
            }

            >>>.el-pagination.is-background .btn-prev {
                color: #439fe3;
                background-color: rgba(49, 88, 128, 0.5) !important;
            }

            >>>.el-pagination.is-background .btn-prev:disabled {
                color: #439fe3;
                background-color: rgba(49, 88, 128, 0.5) !important;
            }

            >>>.el-pagination.is-background .btn-next {
                color: #439fe3;
                background-color: rgba(49, 88, 128, 0.5) !important;
            }

            >>>.el-pagination.is-background .btn-next:disabled {
                color: #439fe3;
                background-color: rgba(49, 88, 128, 0.5) !important;
            }

            >>>.el-pagination.is-background .el-pager li {
                color: #439fe3;
                background-color: rgba(49, 88, 128, 0.5) !important;
            }

            >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #50aaff !important;
                color: #091027;
            }
        }
    }

    .data_list {
        position: absolute;
        top: 0;
        left: 1120px;
        width: 780px;
        height: 848px;
        margin-top: 10px;
        background-color: rgba(29, 68, 149, 0.1);

        .title {
            width: 780px;
            height: 60px;
            font-size: 24px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(center, center);
        }

        .list_title {
            width: 780px;
            height: 48px;
            background: url(../../../assets/img/enter_left_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                width: 126px;
                margin: 0 2px;
                text-align: center;

                &:nth-child(1) {
                    width: 156px;
                }

                &:nth-child(5) {
                    width: 246px;
                }
            }
        }

        .list_box {
            width: 780px;
            height: 740px;

            .box_line {
                width: 780px;
                height: 48px;
                cursor: pointer;
                border-bottom: 1px dashed #1d4495;
                @include flex-box(center, center);

                &:hover {
                    background-color: rgba(49, 88, 128, 0.4);
                }

                .line_item {
                    width: 126px;
                    margin: 0 2px;
                    text-align: center;

                    &:nth-child(1) {
                        width: 156px;
                    }

                    &:nth-child(5) {
                        width: 246px;
                    }
                }
            }
        }
    }

    .active {
        color: #0080FF;
    }

    .dialog_zones {
        .btn_line {
            @include flex-box(center, center);
        }

        .cont_list {
            width: 432px;
            margin: 0 10px;
            height: 660px;
            border-radius: 10px;
            background-color: rgba(29, 68, 149, 0.1);

            .list_title {
                width: 432px;
                height: 48px;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(flex-start, center);

                .title_item {
                    width: 216px;
                    height: 48px;
                    @include flex-box(center, center);

                }
            }

            .list_boxes {
                width: 432px;
                height: 612px;
                position: relative;
                overflow: hidden;

                .list_box {
                    position: absolute;
                    left: 0;
                    right: -25px;
                    top: 0;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: auto;

                    .box_line {
                        width: 432px;
                        height: 70px;
                        margin-top: 5px;
                        font-size: 16px;
                        color: #ffffff;
                        border-bottom: 1px dashed #1d4495;
                        @include flex-box(flex-start, center);

                        &:hover {
                            background-color: rgba(49, 88, 128, 0.4);
                        }

                        .list_item {
                            width: 216px;
                            height: 70px;
                            @include flex-box(center, center);

                        }
                    }
                }
            }
        }


        >>>.el-dialog {
            width: 502px;
            height: 600px;
            margin-top: 20vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4db4f4;
        }

        >>>.el-dialog__title {
            color: #4db4f4;
        }

        >>>.el-dialog__close {
            color: #4db4f4;
        }

        .input_box {
            text-align: center;
            width: 211px;
            height: 30px;
            line-height: 30px;
            padding-left: 15px;
            color: rgba(77, 180, 244, 0.7);
            border-radius: 2px;
            outline: none;
            background: transparent;
            border: none;

            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/views/AlarmPanel/alarmPanelDefault/index.vue